import { captureException } from '@sentry/react'
import { createFileRoute, notFound, redirect } from '@tanstack/react-router'

import { nationalAndFallbackPromotionsQuery } from '@/state/promotions/promotions'

export const Route = createFileRoute('/promotions/$initiativeId/national')({
  beforeLoad: ({ context }) => {
    if (!context.auth.super_admin) {
      if (!context.auth.regionId) {
        throw notFound()
      }

      throw redirect({
        from: Route.fullPath,
        to: '/promotions/$initiativeId/$regionId',
        params: { regionId: context.auth.regionId },
        replace: true,
      })
    }
  },
  loader: async ({ context, params }) => {
    await context.queryClient.prefetchQuery(nationalAndFallbackPromotionsQuery(params.initiativeId))
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
